import { siteSettingsQuery } from "@/lib/sanity";
import { useSanityQuery } from "@/hooks/use-sanity-query";
import type { SiteSettings } from "@/types/content";

export default function AboutSection() {
  const { data: settings } = useSanityQuery<SiteSettings>(["sanity", "siteSettings"], siteSettingsQuery);

  const personalInterests =
    settings?.personalInterests?.length
      ? settings.personalInterests
      : [
          { icon: "🐱", label: "Cat Mom" },
          { icon: "🎭", label: "Cosplayer" },
          { icon: "☕", label: "Coffee Addict" },
          { icon: "📍", label: settings?.location || "United States" },
        ];

  const professionalFocus =
    settings?.professionalFocus?.length
      ? settings.professionalFocus
      : [
          "Zero Trust Architecture & Implementation",
          "Infrastructure Automation & Security",
          "Threat Detection & Response",
          "Cloud Security & Compliance",
        ];

  return (
    <section id="about" className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 font-mono text-pink-400">
            {settings?.aboutHeading || "> whoami"}
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            {settings?.aboutIntro ||
              settings?.description ||
              "Cybersecurity professional with a passion for secure systems, automation, and creative problem-solving. Based in the United States, blending technical expertise with creative pursuits."}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-stretch">
          <div className="glass-card p-8 rounded-2xl animate-slide-up h-full flex flex-col">
            <h3 className="text-2xl font-bold mb-6 text-pink-400 font-mono">
              {settings?.aboutFocusHeading || "Professional Focus"}
            </h3>
            <ul className="space-y-4 text-gray-300">
              {professionalFocus.map((item, index) => (
                <li key={`${item}-${index}`} className="flex items-center">
                  <span className="text-pink-400 mr-3 font-mono">[✓]</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="glass-card p-8 rounded-2xl animate-slide-up h-full flex flex-col">
            <h3 className="text-2xl font-bold mb-6 text-pink-400 font-mono">
              {settings?.aboutInterestsHeading || "Personal Interests"}
            </h3>
            <div className="grid grid-cols-2 gap-4">
              {personalInterests.map((interest, index) => (
                <div key={index} className="text-center p-4 bg-gradient-to-br from-pink-400/10 to-pink-300/10 rounded-lg">
                  <span className="text-2xl mb-2 block">{interest.icon}</span>
                  <span className="font-mono text-sm">{interest.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
